import { render, staticRenderFns } from "./FreightCalculatorBlock.vue?vue&type=template&id=2248bb40&scoped=true&"
import script from "./FreightCalculatorBlock.vue?vue&type=script&lang=js&"
export * from "./FreightCalculatorBlock.vue?vue&type=script&lang=js&"
import style0 from "./FreightCalculatorBlock.vue?vue&type=style&index=0&id=2248bb40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2248bb40",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormSlider: require('/var/www/ct-frontend/ct-front-20261029043307/components/form/FormSlider.vue').default})
